<!-- 定时管理 -->
<template>
    <div class='container containerBox'>
        <!-- 头部筛选区 -->
        <div class="handle-box">
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <el-form-item label="名称">
                   <el-input v-model="handleForm.timername" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="分类">
                    <el-cascader
                        expand-trigger="hover"
                        clearable
                        :options="time_kind"
                        :props="{
                            label: 'label',
                            value: 'id'
                        }"
                        change-on-select
                        v-model="handleForm.timerkind">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top:20px;">
            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
            <el-button size="small" type="primary" @click="handleSetType">设置定时分类</el-button>
            <el-button size="small" type="primary" @click="handleDisable('open')">启用所有定时</el-button>
            <el-button size="small" type="primary" @click="handleDisable('close')">禁用所有定时</el-button>
        </div>
        <div>
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <span style="line-height:26px;">时间设置：{{fmtSetTime(props.row.TimerTime)}}</span>
                            </el-col>
                            <el-col :span="12">
                                <span style="line-height:26px;">控制方式：{{fmtSetControlDev(props.row.TimerControlDev)}}</span>
                            </el-col>
                            <el-col :span="24">
                                <span style="line-height:26px;">控制参数：{{fmtSetControlVal(props.row)}}</span>
                            </el-col>
							<el-col :span="12">
                                <span style="line-height:26px;">控制对象：{{fmtSetControlDevlist(props.row.TimerControlDev)}}</span>
							</el-col>
                        </el-row>
                    </template>
                    </el-table-column>
                <el-table-column
                    prop="Timername"
                    label="名称">
                </el-table-column>
                <el-table-column
                    prop="Enable"
                    label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enable ? 'success': 'danger'">{{scope.row.Enable ? "开启" : "关闭"}}</el-tag>
                    </template>
                </el-table-column> 
                <el-table-column
                    prop="Timerkind"
                    label="分类" :formatter="fmtTimerKind">
                </el-table-column>
                <el-table-column
                    prop="Devtype"
                    label="控制设备"
                    :formatter="fmtDevtype">
                </el-table-column>
                <el-table-column
                    prop="Description"
                    label="说明">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.Enable" @click="handleControlTime(true, scope.row)" type="text" size="small">启用</el-button>
                        <el-button v-else @click="handleControlTime(false, scope.row)" type="text" size="small">关闭</el-button>
                        <el-button @click="handleDetele(scope.row)" type="text" size="small">删除</el-button>
                        <el-button type="text"  @click="handleEdit(scope.row)" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 定时分类管理 -->
        <cmp-timing-classify :visible="visibleChoseMeter" @handleCloseDialog="handleCloseDialog"></cmp-timing-classify>
    </div>
</template>

<script>
import CmpTimingClassify from './CmpTimingClassify'
import { mapGetters } from 'vuex'
import { $Alert } from '@/utils/utils'
import { timerChildrenIds, flatten } from '@/utils/array'
import Service from '@/api/Service'
import { CLUSTERMANA, CLUSTERMANA_1 } from '@/api/configData'

export default {
    name:  'timingmana',
    inject: ["reload"],
    data() {
        return {
            handleForm: {
                timername:'',
                timerkind: [],
            },
            tableData: [],  //  定时列表
			proname:[],
            // 分类框
            visibleChoseMeter: false,

        };
    },

    components: {
        CmpTimingClassify
    },

    computed: {
        ...mapGetters(['timeKind']),
        time_kind() {
            if(!this.timeKind.Timerkind) return []
            return JSON.parse(this.timeKind.Timerkind)
        }
    },

    mounted() {
        this.onSubmit()
    },

    methods: {
		//获取设备信息
		// getinfo(item){
		// 	let arr=[]
		// 	item.map(v=>{
		// 		// if(v.TimerControlDev != '{}'){
		// 		// 	var oid= JSON.parse(v.TimerControlDev).data[0].value
		// 		// 	arr.push(oid)
		// 		// }
		// 	})
		// 	arr = [...new Set(arr)];
		// 	this.getdata(arr)
		// },
		// getdata(arr){
		// 	arr[arr.length] = '0'
		// 	arr.map(async v=>{
		// 		let res = await Service.getTerminalbyidInfo({oid:v})
		// 		if(res && res !='success'){
		// 			this.proname.push({oid: res[0].OID,name:res[0].HouseHoldName})
		// 		}
		// 	})
		// },
        // 查询
        async onSubmit() {
            let obj = Object.assign({}, this.handleForm);
            if(obj.timerkind.length) {
                // 获取最末端ID集合
                let id = obj.timerkind[obj.timerkind.length-1]
                let ids = timerChildrenIds(this.time_kind, id);
                obj.timerkind = ids.map(v=>{ return { timerkind: v } })
            }
            let data = await Service.getTimerList(obj);
            if(data) {
                
                data = data === 'success' ? [] : data;
				// this.getinfo(data)
                this.tableData = data;
            }
        },
        // 新增定时
        handleAdd() {
            this.$router.push('/timing/addtiming/0')
        },
        // 定时分类
        handleSetType() {
            this.visibleChoseMeter = true;
        },
        // 关闭
        handleCloseDialog() {
            this.visibleChoseMeter = false;
        },
        // 开启关闭所有
        handleDisable(type) {
            let oid_array = []
            let enable;
            switch (type) {
                case 'open':
                    enable = true;
                    this.tableData.map(v=>{
                        if(!v.Enable){
                            oid_array.push({oid: v.OID + ""})
                        }
                    })
                    break;
                case 'close':
                    enable = false;
                    this.tableData.map(v=>{
                        if(v.Enable){
                            oid_array.push({oid: v.OID + ""})
                        }
                    })
                    break;
                default:
                    break;
            }

            this.setTimer(enable, oid_array);
        },
        // 开启当前定时器
        handleControlTime(enable, row) {
            // 开启或关闭
            let oid_array = [{oid: row.OID + ""}]
            this.setTimer(enable, oid_array)
        },
        async setTimer(enable, oid_array) {
            let data = await Service.setEnable({oid_array, enable})
            if(data) {
                this.$message({
                    type: "success",
                    message: "操作成功"
                });
                this.onSubmit()
            }
        },
        // 删除
        handleDetele(row) {
            $Alert(`确认删除${row.Timername}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    let data = await Service.delTimer({OID: row.OID})
                    if(data) {
                        this.$message({
                            type: "success",
                            message: "删除成功"
                        });
                        this.onSubmit()
                    }
                }
            });
        },
        // 编辑
        handleEdit(row) {
            this.$router.push('/timing/addtiming/' + row.OID)
        },
        fmtDevtype(row) {
            return row.Devtype == '1' ? "风盘" : "风柜"
        },
        // 格式化分类
        fmtTimerKind(row) {
            let arr = flatten(this.time_kind);
            let cur = arr.filter(v=> {return v.id === row.Timerkind})
            return cur.length > 0 ? cur[0].label : ""
        },
        // 格式化控制时间
        fmtSetTime(time) {
            let data = JSON.parse(time);
            let str = ""
            if (data.type === 'day') {
                let dates = data.data.map(v => { return v.value});
                str += dates.join("、")
            } 
            if (data.type === 'week') {
                let dates = data.data.map(v => { 
                    switch (v.value) {
                        case '1':
                            return "星期一"
                        case '2':
                            return "星期二"
                        case '3':
                            return "星期三"
                        case '4':
                            return "星期四"
                        case '5':
                            return "星期五"   
                        case '6':
                            return "星期六" 
                        case '7':
                            return "星期日" 
                        default:
                            break;
                    }
                });
                str += dates.join("、")
            }
            return str + " / " + data.time
        },
        // 格式化控制对象
        fmtSetControlDev(controlDev) {
            let data = JSON.parse(controlDev);
            let str = "";
            if(data.type == "1") {
                // 控制单台设备
                str += "控制单台设备"
            }
            if(data.type == "2") {
                // 控制分组
                str += "控制分组设备"
            }
            if(data.type == "3") {
                // 控制所有
                str += "控制所有设备"
            }
            return str
        },
		// 格式化设备列表
		fmtSetControlDevlist(controlDev) {
			let data = JSON.parse(controlDev);
			let str=data.controlname
			return str
		},
        // 格式化控制参数
        fmtSetControlVal(row) {
            let str = '';
            let data = JSON.parse(row.TimerControlValue);
            data.map(v=>{
                let V = v["V"]
                let N = v["N"];
                if (V) {
                    switch (N) {
                        case "setting_power_on":
                            str += "状态：" + this.fmtControlForm("status", V) + " / "
                            break;
                        case "setting_mode":
                            str += "模式：" + this.fmtControlForm("pattern", V) + " / "
                            break;
                        case "setting_speed":
                            str += "风速：" + this.fmtControlForm("windSpeed", V) + " / "
                            break;
                        case "setting_key_lock":
                            str += "锁定：" + this.fmtControlForm("lock", V) + " / "
                            break;
                        case "setting_op_at_acback":
                            str += "来电启动状态：" + this.fmtControlForm("DDGK", V) + " / "
                            break;
                        case "setting_allow_ventilation":
                            str += "通风模式使能：" + this.fmtControlForm("windMode", V) + " / "
                            break;
                        case "setting_heating_temperature":
                            str += "制热温度：" + V + " / "
                            break;
                        case "setting_cooling_temperature":
                            str += "制冷温度：" + V + " / "
                            break;
                        case "setting_temperature":
                            str += "设温：" + V + " / "
                            break;
                        case "power_on":
                            str += "开关机：" + this.fmtControlForm1("power_on", V) + " / "
                            break;
                        case "speed":
                            str += "风速：" + this.fmtControlForm1("speed", V) + " / "
                            break;
                        case "mode":
                            str += "模式：" + this.fmtControlForm1("mode", V) + " / "
                            break;
                        case "temperature":
                            str += "设温：" + V + " / "
                            break;
                        case "key_lock":
                            str += "按键锁：" + this.fmtControlForm1("key_lock", V) + " / "
                            break;
                        default:
                            break;
                    }
                }
            })
            
            return str
        },
		fmtControlFormname(val) {
			let cur = this.proname.filter(v=>{return val===v.oid })
			if(cur.length) return cur[0].name
			return ""
		},
        fmtControlForm(key,val) {
            let cur = CLUSTERMANA[key].filter(v=>{return val===v.value })
            if(cur.length) return cur[0].label
            return ""
        },
        fmtControlForm1(key,val) {
            let cur = CLUSTERMANA_1[key].filter(v=>{return val===v.value})
            if(cur.length) return cur[0].label
            return ""
        }

    }
}

</script>